export default "__VITE_ASSET__BLLjwCPk__"